import { viewerStrings } from '../copy/strings.js';
import { hasText, optionalText } from '../copy/text.js';
import type { ClassificationRule } from '../state/rules-state.js';

type Condition = ClassificationRule['conditions'][number];
export function RuleCondition({
  condition,
  change,
  remove,
}: {
  condition: Condition;
  change: (condition: Condition) => void;
  remove: () => void;
}) {
  return (
    <div className="field-tools" data-copy-group>
      <select
        aria-label={optionalText(viewerStrings.webComponentsRuleCondition.conditionField)}
        value={condition.field}
        onChange={(event) => {
          const field = event.target.value as Condition['field'];
          change({ field, op: 'eq', value: '' });
        }}
      >
        {hasText(viewerStrings.webComponentsRuleCondition.device) ? (
          <option value="device">{viewerStrings.webComponentsRuleCondition.device}</option>
        ) : null}
        {hasText(viewerStrings.webComponentsRuleCondition.number) ? (
          <option value="number">{viewerStrings.webComponentsRuleCondition.number}</option>
        ) : null}
        {hasText(viewerStrings.webComponentsRuleCondition.partition) ? (
          <option value="partition">{viewerStrings.webComponentsRuleCondition.partition}</option>
        ) : null}
      </select>
      <select
        aria-label={optionalText(viewerStrings.webComponentsRuleCondition.conditionOperator)}
        value={condition.op}
        onChange={(event) => {
          const op = event.target.value as Condition['op'];
          change(
            op === 'range'
              ? { field: 'number', op, start: '', end: '' }
              : {
                  field: condition.field,
                  op,
                  value: condition.op === 'range' ? '' : condition.value,
                },
          );
        }}
      >
        {hasText(viewerStrings.webComponentsRuleCondition.beginsWith) ? (
          <option value="prefix">{viewerStrings.webComponentsRuleCondition.beginsWith}</option>
        ) : null}
        {condition.field === 'number' &&
          (hasText(viewerStrings.webComponentsRuleCondition.betweenInclusive) ? (
            <option value="range">
              {viewerStrings.webComponentsRuleCondition.betweenInclusive}
            </option>
          ) : null)}
        {hasText(viewerStrings.webComponentsRuleCondition.equals) ? (
          <option value="eq">{viewerStrings.webComponentsRuleCondition.equals}</option>
        ) : null}
      </select>
      {condition.op === 'range' ? (
        <>
          <input
            aria-label={optionalText(viewerStrings.webComponentsRuleCondition.rangeStart)}
            placeholder={optionalText(viewerStrings.webComponentsRuleCondition.text)}
            value={condition.start}
            maxLength={32}
            onChange={(event) => change({ ...condition, start: event.target.value })}
          />
          <input
            aria-label={optionalText(viewerStrings.webComponentsRuleCondition.rangeEnd)}
            placeholder={optionalText(viewerStrings.webComponentsRuleCondition.text2)}
            value={condition.end}
            maxLength={32}
            onChange={(event) => change({ ...condition, end: event.target.value })}
          />
        </>
      ) : (
        <input
          aria-label={optionalText(viewerStrings.webComponentsRuleCondition.conditionValue)}
          value={condition.value}
          maxLength={256}
          onChange={(event) => change({ ...condition, value: event.target.value })}
        />
      )}
      {hasText(viewerStrings.webComponentsRuleCondition.remove) ? (
        <button
          type="button"
          aria-label={optionalText(viewerStrings.webComponentsRuleCondition.removeCondition)}
          onClick={remove}
        >
          {viewerStrings.webComponentsRuleCondition.remove}
        </button>
      ) : null}
    </div>
  );
}
